// Keep deliberate funnel/product events and pageviews at full fidelity. Avoid
// charging for every DOM interaction, navigation exit, and routine auth refresh.
export const posthogVolumeOptions = {
  autocapture: false,
  rageclick: false,
  capture_dead_clicks: false,
  capture_heatmaps: false,
  capture_performance: false,
  capture_pageleave: false,
} as const;

const discardedEvents = new Set([
  '$autocapture',
  '$rageclick',
  '$dead_click',
  '$heatmap_data',
  '$web_vitals',
  '$pageleave',
  'INITIAL_SESSION',
  'TOKEN_REFRESHED',
  'USER_UPDATED',
  // Consent changes and checkout selections already have dedicated events.
  'cookie_banner_clicked',
  'checkout_faq_opened',
  'lifetime_funnel_order_summary_updated',
]);

// Apply at the SDK boundary too, so legacy call sites and remote settings cannot
// accidentally reintroduce these events. Do not sample conversions or pageviews.
export function filterPosthogEvent<T extends { event: string }>(event: T | null): T | null {
  return event && !discardedEvents.has(event.event) ? event : null;
}
